const $$splitComponentImporter = () => import('/Users/lois/Documents/GitHub/zephyr/repos/storage-viewer/src/routes/keys.$namespaceId.$key.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
export const Route = createFileRoute('/keys/$namespaceId/$key')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  loader: ({
    params
  }) => {}
});